export default "__VITE_ASSET__CYc_4T4g__"